import React, { useMemo } from 'react'
import { ThemeProvider, createTheme } from '@mui/material/styles'
import { getUserLocation } from '../../common/get-user-location'
import { EyeIcon, DropDownArrow } from '../../../components/common/svg-icons/index'
import GiftContext from '../../../context/context'
import PhoneField from '../../common/phone-field/PhoneField'
import ClassicCheckbox from '../../common/classic-checkbox'
import InputLabel from '@mui/material/InputLabel'
import MenuItem from '@mui/material/MenuItem'
import FormControl from '@mui/material/FormControl'
import Select from '@mui/material/Select'
import { IconButton, InputAdornment, TextField } from '@mui/material'
import {
  countriesList,
  getStates,
} from '../texts/select-static-data'

const theme = createTheme({
  palette: {
    primary: {
      main: '#646771',
    },
  },
})

const CountriesListSelector = ({ value, handler }) => {
  const list = useMemo(() => countriesList.map(item => item.name), [])
  return (
    <FormControl fullWidth>
      <InputLabel id='country-id'>Country<span style={{ color: '#d8353b' }}>*</span></InputLabel>
      <Select
        IconComponent={DropDownArrow}
        labelId='country-id'
        id='country-select'
        value={value}
        label='Country'
        onChange={e => {
          handler('country', e.target.value)
          handler('state', '')
        }
        }
      >
        {list.map(item => (
          <MenuItem value={item} key={item}>
            {item}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  )
}

export default class FormRegistration extends React.Component {
  static contextType = GiftContext
  state = {
    currentCard: '',
    errorCard: false,
    isPasswordShowed: false,
  }

  recolorImportantMark(str) {
    if (str.includes('*')) {
      const body = str.split('*')
      return <>{body}<span style={{ color: '#d8353b' }}>*</span></>
    }
    return str
  }

  render() {
    const { country } = getUserLocation()
    const { questionnaire } = this.props

    return (
      <ThemeProvider theme={theme}>
        <GiftContext.Consumer>
          {({ formContent, formData, handleChangeField, renderError }) => {
            const countryByIp = countriesList.find(item => item.code === country.toLowerCase())?.name
            const chosenCountry = formData.country
            if (questionnaire.some(item => item.required) && !formData.dynamicValidation) {
              const val = questionnaire.filter(i => i.required).map(j => `category${j.category}`).join('#$#')
              setTimeout(() => {
              handleChangeField('dynamicValidation', val)
              }, 0)
            }
            if (countryByIp && !chosenCountry) {
              setTimeout(() => {
                handleChangeField('country', countryByIp)
              }, 0)
            }
            return (
              <div className='form-state --registration'>
                <div className='mb-2 relative'>
                  <TextField
                    fullWidth
                    label={this.recolorImportantMark(formContent.texts.name)}
                    value={formData.name}
                    onChange={e => handleChangeField('name', e.target.value)}
                  />
                  {renderError('name') ? <div className='mui__input__error'>{renderError('name')}</div> : null}
                </div>
                <div className='mb-2 relative'>
                  <TextField
                    fullWidth
                    label={this.recolorImportantMark(formContent.texts.email)}
                    value={formData.email}
                    onChange={e => handleChangeField('email', e.target.value)}
                  />
                  {renderError('email') ||
                  renderError('email.notvalid') ||
                  renderError('email.exists') ? <div className='mui__input__error'>{renderError('email') ||
                  renderError('email.notvalid') ||
                  renderError('email.exists')}</div> : null}
                </div>
                {this?.props?.code === 'BOCAWEST23' ? <div className='bocawest-phone-message'>Mobile Phone Number</div> : null}
                <div className='form-field field-phone relative'>
                  <div
                    className={`phone-input mb-2 ${
                      formData.errors.includes('phone.notvalid') ? 'error' : ''
                    }`}
                  >
                    <PhoneField
                      className='integrated'
                      name='phone'
                      country={country || 'us'}
                      value={formData.phone}
                      onChange={handleChangeField}
                      callback={val => {
                        handleChangeField('country', val)
                        if(val !== formData.country ){
                          handleChangeField('state', '')
                        }
                      }}
                    />
                  </div>
                  <div className='mui__input__error'>{renderError('phone.notvalid')}</div>
                </div>
                <div className='mb-2 relative'>
                  <TextField
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position='end'>
                          <IconButton
                            aria-label='toggle password visibility'
                            onClick={() => this.setState({ isPasswordShowed: !this.state.isPasswordShowed })}
                          >
                            <EyeIcon isRed={this.state.isPasswordShowed} />
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                    fullWidth
                    autoComplete='off'
                    label={this.recolorImportantMark(formContent.texts.password)}
                    type={this.state.isPasswordShowed ? 'text' : 'password'}
                    value={formData.password}
                    onChange={e => handleChangeField('password', e.target.value)}
                  />
                  {renderError('password') || renderError('password.tooshort') ? <div
                    className='mui__input__error'>{renderError('password') || renderError('password.tooshort')}</div> : null}
                </div>
                <div>
                  <div className='mb-2 relative'>
                    <CountriesListSelector handler={handleChangeField} value={formData.country} />
                    {renderError('country') ?
                      <div className='mui__input__error'>{renderError('country')}</div> : null}
                  </div>
                  {chosenCountry === 'Canada' || chosenCountry === 'United States' ? (
                    <div className='mb-2 relative'>
                      <FormControl fullWidth>
                        <InputLabel id='state-id'>State<span style={{ color: '#d8353b' }}>*</span></InputLabel>
                        <Select
                          IconComponent={DropDownArrow}
                          labelId='state-id'
                          id='state-select'
                          value={formData.state}
                          label='State'
                          onChange={e => handleChangeField('state', e.target.value)}
                        >
                          {chosenCountry === 'United States' ? (
                            getStates(true, true).map((item, idx) => (
                              <MenuItem key={idx} value={item.value}>{item.title}</MenuItem>
                            ))
                          ) : null}
                          {chosenCountry === 'Canada' ? (
                            getStates(false, true).map((item, idx) => (
                              <MenuItem key={idx} value={item.value}>{item.title}</MenuItem>
                            ))
                          ) : null}

                        </Select>
                      </FormControl>
                      {renderError('state') ? <div className='mui__input__error'>{renderError('state')}</div> : null}
                    </div>
                  ) : null}
                  {questionnaire.map(item => (
                    <div className='mb-2 relative' key={item.category}>
                      <FormControl fullWidth>
                        <InputLabel className={item.name.length > 29 ? 'label-mui' : ''} id={'id' + item.category}>
                          {item.name}
                          {item.required ? <span style={{ color: '#d8353b' }}>*</span> : null}
                        </InputLabel>
                        <Select
                          multiple={false} //  multiple={item.selectionType === 1} for multiselect
                          IconComponent={DropDownArrow}
                          labelId={'id' + item.category}
                          id={item.responseKey}
                          value={formData[`category${item.category}`] || (item.selectionType === 1 ? [] : '')}
                          label={item.name}
                          onChange={e => handleChangeField(`category${item.category}`, e.target.value)}
                        >
                          {item.required ? null : <MenuItem key={0} value={''}><span style={{opacity: 0}}>None</span></MenuItem>}
                          {item?.options.map((optItem, idx) => (
                            <MenuItem key={idx + 1}
                                      //className={item.selectionType === 1 && formData?.[`category${item.category}`]?.includes(`${optItem.id}#$#${optItem.name}#$#${item.category}`) ? 'mui__input__bold' : ''}
                                      value={`${optItem.id}#$#${optItem.name}#$#${item.category}`}>{optItem.name}</MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                      {renderError(`category${item.category}`) ? <div className='mui__input__error'>{renderError(`category${item.category}`)}</div> : null}
                    </div>
                  ))}
                </div>
                <div className='form-field form-checkbox form-mb-16'>
                  <ClassicCheckbox
                    id='privacyPolicy'
                    name='privacyPolicy'
                    checked={formData.privacyPolicy}
                    onChange={() => handleChangeField('privacyPolicy', !formData.privacyPolicy)}
                  />
                  <p className='checkbox-text' style={{ color: '#393B41' }}>
                    {formContent.agreements}
                  </p>
                </div>
                {formData.errors.some((error) => ['privacyPolicy'].includes(error)) ? (
                  <p style={{ marginBottom: '10px' }} className='error-message'>{formContent.texts.termsErr}</p>
                ) : null}
                <div className='form-field form-checkbox form-mb-16'>
                  <ClassicCheckbox
                    id='privacyPolicy2'
                    name='privacyPolicy2'
                    checked={formData.privacyPolicy2}
                    onChange={() => handleChangeField('privacyPolicy2', !formData.privacyPolicy2)}
                  />
                  <p className='checkbox-text' style={{ color: '#393B41' }}>
                    {formContent.agreements2}
                  </p>
                </div>
                {formData.errors.some((error) => ['privacyPolicy2'].includes(error)) ? (
                  <p style={{ marginBottom: '10px' }} className='error-message'>{formContent.texts.termsErr2}</p>
                ) : null}
              </div>
            )
          }}
        </GiftContext.Consumer>
      </ThemeProvider>
    )
  }
}
